import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { useListaPrecioStore } from '../store/listaPrecioStore';

export const ListaPreciosPage: React.FC = () => {
  const navigate = useNavigate();
  const { listas, loading, fetchListas } = useListaPrecioStore();

  useEffect(() => { fetchListas(); }, [fetchListas]);

  const columns: GridColDef[] = [
    { field: 'nombre', headerName: 'Nombre', flex: 1, minWidth: 200 },
    { field: 'descripcion', headerName: 'Descripcion', flex: 1, minWidth: 200 },
    { field: 'moneda', headerName: 'Moneda', width: 100, valueGetter: (value: any) => value?.abreviatura || '-' },
    { field: 'fechaInicio', headerName: 'Inicio', width: 110, valueFormatter: (value: string) => value ? new Date(value).toLocaleDateString('es-PE') : '-' },
    { field: 'fechaFin', headerName: 'Fin', width: 110, valueFormatter: (value: string) => value ? new Date(value).toLocaleDateString('es-PE') : '-' },
    { field: 'activo', headerName: 'Estado', width: 100, renderCell: (params) => <Chip label={params.value ? 'Activo' : 'Inactivo'} color={params.value ? 'success' : 'default'} size="small" /> },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Listas de Precio</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/ventas/lista-precios/nueva')}>Nueva Lista</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid rows={listas} columns={columns} getRowId={(row) => row.idListaPrecio} loading={loading}
          pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/ventas/lista-precios/${params.row.idListaPrecio}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick />
      </Paper>
    </Box>
  );
};
